import { useState, useEffect } from 'react';
import api from '../../api';
import { useAuth } from '../../context/AuthContext';
import { downloadExcel } from '../../utils/excelExport';

const MATCH_LABELS = { phrase: 'Фраза в назначении платежа', inn: 'ИНН контрагента', contractor: 'Название контрагента' };

export default function Rules() {
  const { user } = useAuth();
  const [meta, setMeta] = useState(null);
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [matchType, setMatchType] = useState('phrase');
  const [matchValue, setMatchValue] = useState('');
  const [articleId, setArticleId] = useState('');
  const [projectId, setProjectId] = useState('');
  const [error, setError] = useState('');
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);

  const load = () => {
    setLoading(true);
    api.get('/finance/rules').then(r => setRules(r.data)).finally(() => setLoading(false));
  };

  useEffect(() => { api.get('/finance/meta').then(r => setMeta(r.data)); load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    setError(''); setNote('');
    if (!matchValue.trim() || !articleId) { setError('Заполните значение и статью'); return; }
    setSaving(true);
    try {
      const { data } = await api.post('/finance/rules', { match_type: matchType, match_value: matchValue.trim(), article_id: Number(articleId), project_id: projectId || null });
      setNote(data.backfilled > 0 ? `Правило создано. Сразу размечено ${data.backfilled} операций в очереди.` : 'Правило создано.');
      setMatchValue(''); setArticleId(''); setProjectId('');
      load();
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка сохранения');
    } finally { setSaving(false); }
  };

  const toggleActive = async (rule) => {
    await api.patch(`/finance/rules/${rule.id}`, { is_active: !rule.is_active });
    load();
  };

  const remove = async (rule) => {
    if (!window.confirm('Удалить правило?')) return;
    await api.delete(`/finance/rules/${rule.id}`);
    load();
  };

  const exportRules = () => downloadExcel(
    'Правила категоризации',
    ['Тип', 'Значение', 'Статья', 'Проект', 'Автор', 'Статус'],
    rules.map(r => [
      MATCH_LABELS[r.match_type], r.match_value, r.article_name || '—', r.project_name || '—',
      r.created_by_name || '—', r.is_active ? 'Активно' : 'Отключено',
    ])
  );

  if (!meta) return <div className="loading-text">Загрузка...</div>;

  return (
    <div>
      <p className="text-muted mb-2">
        Явное правило: ключевая фраза, ИНН или название контрагента → статья (и, при необходимости, проект).
        Совпавшие банковские операции размечаются сразу, без ожидания.
      </p>
      <form className="toolbar" onSubmit={add}>
        <select value={matchType} onChange={e => setMatchType(e.target.value)}>
          {Object.entries(MATCH_LABELS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
        <input placeholder="Значение для сравнения" value={matchValue} onChange={e => setMatchValue(e.target.value)} style={{ minWidth: 220 }} />
        <select value={articleId} onChange={e => setArticleId(e.target.value)}>
          <option value="">Статья</option>
          {meta.articles.map(a => <option key={a.id} value={a.id}>{a.section_name} / {a.name}</option>)}
        </select>
        <select value={projectId} onChange={e => setProjectId(e.target.value)}>
          <option value="">Без проекта</option>
          {meta.projects.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select>
        <button type="submit" className="btn-primary btn-sm" disabled={saving}>Добавить правило</button>
      </form>
      {error && <div className="error-msg">{error}</div>}
      {note && <div className="stat-card mb-2" style={{ maxWidth: 480 }}>{note}</div>}

      {loading ? <div className="loading-text">Загрузка...</div> : rules.length === 0 ? (
        <div className="empty-state">Правил пока нет</div>
      ) : (
        <div className="table-wrap">
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
            <button className="btn-secondary btn-sm" onClick={exportRules}>Экспорт в Excel</button>
          </div>
          <table>
            <thead><tr><th>Тип</th><th>Значение</th><th>Статья</th><th>Проект</th><th>Автор</th><th>Статус</th><th></th></tr></thead>
            <tbody>
              {rules.map(r => (
                <tr key={r.id}>
                  <td>{MATCH_LABELS[r.match_type]}</td>
                  <td>{r.match_value}</td>
                  <td>{r.article_name || '—'}</td>
                  <td>{r.project_name || '—'}</td>
                  <td>{r.created_by_name || '—'}</td>
                  <td><span className={`badge ${r.is_active ? 'badge-paid' : 'badge-rejected'}`}>{r.is_active ? 'Активно' : 'Отключено'}</span></td>
                  <td>
                    <button className="btn-secondary btn-sm" onClick={() => toggleActive(r)}>{r.is_active ? 'Отключить' : 'Включить'}</button>{' '}
                    {user.role === 'admin' && <button className="btn-danger btn-sm" onClick={() => remove(r)}>Удалить</button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
